import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_offline_icon = _resolveComponent("offline-icon")!

  return (_ctx.id)
    ? (_openBlock(), _createBlock(_component_offline_icon, {
        key: 0,
        icon: _ctx.id
      }, null, 8, ["icon"]))
    : _createCommentVNode("", true)
}